import { createSlice } from '@reduxjs/toolkit';

export const myCouponList = createSlice({
  name: 'myCouponList',
  initialState: {
    data: [],
  },

  reducers: {
    setMyCouponList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setMyCouponList } = myCouponList.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getMyCouponList = (state) => {
  return state.myCouponList.data;
};

export default myCouponList.reducer;
